import { Anchor, Button, Form, Input, message } from "antd";
import { Image } from "cloudinary-react";
import moment from "moment";
import { NewsArticleJsonLd, NextSeo } from "next-seo";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { FaFacebookSquare, FaLinkedin } from "react-icons/fa";
import { useMediaQuery } from "react-responsive";
import useSWR from "swr";
import Footer from "../../components/global/Footer/Footer";
import Tag from "../../components/global/Tag/Tag";
import ArticleGuides from "../../components/guides/ArticleGuides";
import fetcher from "../../fetchers/fetcher";
import HttpService from "../../services/HttpService";
import { ArticleWrapper } from "./Article.style";
import { default as NextLink } from "next/link";
import TestOutilForm from "../../components/TestOutilForm/TestOutilForm";

export default function Article({ article, articles }) {
  const router = useRouter();

  // const { data: article } = useSWR(
  //   process.env.API_URL + "/articles/" + router.query.slug,
  //   fetcher
  // );
  // const { data: articles } = useSWR(
  //   process.env.API_URL + "/articles/getThreeLast/" + router.query.slug,
  //   fetcher
  // );

  // if (!article || !articles) {
  //   return <>loading...</>;
  // }

  const { slug } = router.query;
  const isDesktop = useMediaQuery({ minWidth: 1024 });
  const { Link } = Anchor;
  const titles = [];
  article.sections.map((section, index) => {
    titles.push({ slug: section.slug, text: section.title });
  });

  const [currentAnchor, setCurrentAnchor] = useState(null);

  const onAnchorChange = (e) => {
    setCurrentAnchor(e);
  };

  const anchorShouldBeDisplayed = (index) => {
    const currentIndex = titles.findIndex(
      (title) => "#" + title.slug === currentAnchor
    );
    if (!currentAnchor || !currentIndex) {
      return index < 3;
    }
    if (currentIndex == titles.length - 1) {
      return index > titles.length - 4;
    }
    return index > currentIndex - 2 && index < currentIndex + 2;
  };

  const [sendMailLoading, setSendMailLoading] = useState(false);
  const [scrollPosition, setScrollPosition] = useState(0);
  const handleScroll = () => {
    const position = window.pageYOffset;
    setScrollPosition(position);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleSendMail = (values) => {
    setSendMailLoading(true);
    const http = new HttpService();
    http
      .postData(values, "send-email-advice")
      .then((response) => {
        message.success(response);
        setSendMailLoading(false);
        setTimeout(() => {
          window.open("/start", "_ blank");
        }, 2000);
      })
      .catch((response) => {
        message.error(response);
        setSendMailLoading(false);
      });
  };

  return (
    <ArticleWrapper>
      <NextSeo
        title={article.title + " - Easy Capital"}
        description={article.meta_description}
        openGraph={{
          url: "https://www.easycapital.fr/easynews/" + slug,
          title: article.tile,
          description: article.meta_description,
          images: [
            {
              url: article.photo?.photo,
            },
          ],
          site_name: "Easy Capital",
        }}
      />
      <NewsArticleJsonLd
        url={"https://www.easycapital.fr/easynews/" + slug}
        title={article.title}
        images={[article.photo?.photo]}
        // section="politic"
        tags={article.tags.map((tag, index) => (index ? "," : "") + tag.title)}
        keywords={article.keywords.map(
          (keyword, index) => (index ? "," : "") + keyword.title
        )}
        datePublished={article.created_at}
        dateModified={article.updated_at}
        authorName="Antoine Vincent"
        description={article.meta_description}
        // body={article.formatted_d}
      />
      <div className="titleWrapper">
        <h1 class="mainTitle">{article.title}</h1>
        <hr className="divider" />
      </div>
      {article.photo && (
        <Image
          cloudName="easycapital"
          className="coverPic"
          src={article.photo.photo}
          alt={article.photo.description ?? "article picture"}
        />
      )}
      <div className="articleContentWrapper">
        <div className={"articleContent " + slug}>
          <div className="contentHeader">
            <div>
              {article.reading_time && (
                <p className="readingTime">
                  Temps de lecture : ~ {article.reading_time} min
                </p>
              )}
              <p>Publié le {moment(article.created_at).format("DD/MM/YYYY")}</p>
            </div>
            <div className="tags">
              {article.tags.map((tag, index) => {
                return <Tag title={tag.title} key={index} />;
              })}
            </div>
          </div>
          <p className="mainTitle">
            <strong>{article.title}</strong>
          </p>
          <div
            className="htmlContent"
            dangerouslySetInnerHTML={{
              __html: article.content,
            }}
          />
          <br />
          {article.sections.map((section, i) => (
            <div className="htmlContent" key={i}>
              {section.photo && (
                <img
                  src={section.photo.photo}
                  alt={section.photo.description}
                />
              )}
              <h2 id={section.slug}>
                <strong>{section.title}</strong>
              </h2>
              <div
                dangerouslySetInnerHTML={{
                  __html: section.formatted_description,
                }}
              />
              <br />
              {i == 1 && (
                <TestOutilForm title="Tester notre outil de gestion de patrimoine en ligne" classname="article" />
              )}
            </div>
          ))}
          <div className="writterWrapper">
            <p className="writter">
              Rédigé par{" "}
              <a
                href={article.author?.linkedin ? article.author.linkedin : "https://www.linkedin.com/in/antoine-vincent-83260b158/" }                
                target={"_blank"}
              >
                {article.author?.fullname ? article.author.fullname : "Antoine" }
              </a>
            </p>
            <p className="share">
              Partagez
              <a
                href={
                  "https://www.facebook.com/sharer/sharer.php?u=www.easycapital.fr" +
                  router.asPath
                }
              >
                <FaFacebookSquare className="fb" />
              </a>
              <a
                href={
                  "https://www.linkedin.com/shareArticle?url=www.easycapital.fr" +
                  router.asPath +
                  "&title=" +
                  article.title
                }
              >
                <FaLinkedin className="lk" />
              </a>
            </p>
          </div>
        </div>
        <div className="sticky">
          {isDesktop && (
            <Anchor
              offsetTop={100}
              targetOffset={100}
              getContainer={() => window}
              // affix={false}
              // showInkInFixed={true}
              onChange={onAnchorChange}
            >
              {scrollPosition < document.body.scrollHeight - 1250 && (
                <div className="stickySummary">
                  <strong>Sommaire</strong>
                  {titles.length > 3 && !anchorShouldBeDisplayed(0) && (
                    <>
                      <br />
                      ...
                    </>
                  )}
                  {titles.map(
                    (title, index) =>
                      anchorShouldBeDisplayed(index) && (
                        <Link
                          href={"#" + title.slug}
                          title={title.text}
                          key={index}
                        />
                      )
                  )}
                  {titles.length > 3 &&
                    !anchorShouldBeDisplayed(titles.length - 1) &&
                    "..."}
                  <div className="links">
                    <a
                      href="https://www.facebook.com/cabineteasycapital"
                      target="_blank"
                    >
                      <FaFacebookSquare className="fb" />
                    </a>
                    <a
                      href="https://www.linkedin.com/company/easy-capital/"
                      target="_blank"
                    >
                      <FaLinkedin className="lk" />
                    </a>
                  </div>
                </div>
              )}
              {scrollPosition < document.body.scrollHeight - 1700 && (
                <div className="stickyLastArticles">
                  <strong>Nos derniers articles</strong>
                  <hr />
                  {articles.map((a, index) => (
                    <div className="lastArticle">
                      <NextLink href={a.slug}>
                        <a>
                          <Image src={a.photo?.photo} />
                          <p>{a.title}</p>
                        </a>
                      </NextLink>
                    </div>
                  ))}
                </div>
              )}
            </Anchor>
          )}
        </div>
      </div>
      <hr className="divider" />
      <div className="otherArticles">
        <h2>Découvrez nos autres articles</h2>
        <div>
          {articles.map((a, index) => {
            return (
              <ArticleGuides
                className="article"
                content={a.meta_description}
                title={a.title}
                date={a.created_at}
                img={a.photo?.photo}
                type={"small"}
                tags={a.tags}
                slug={a.slug}
                key={index}
              />
            );
          })}
        </div>
      </div>
      <Footer />
    </ArticleWrapper>
  );
}
